import { render, staticRenderFns } from "./CoilsProjectDetails.vue?vue&type=template&id=2eceab94&"
import script from "./CoilsProjectDetails.vue?vue&type=script&lang=js&"
export * from "./CoilsProjectDetails.vue?vue&type=script&lang=js&"
import style0 from "./CoilsProjectDetails.vue?vue&type=style&index=0&id=2eceab94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports